import * as React from "react";
import { brancheWahlListe, type BrancheWahl } from "@kmvs/forms-core";
import { BrancheMultiSelect } from "../forms/widgets/BrancheMultiSelect";
import type { BrancheAuswahl } from "../forms/widgets/brancheAuswahlLogik";
import {
  formatBranchePath,
  useBrancheClassification,
} from "../../data/brancheClassification";

/**
 * Branche und Spezialisierung im Fragebogen — dieselbe Auswahl wie in der
 * Kontaktakte.
 *
 * Die Analyse fragte danach bis hierher gar nicht, obwohl der Kontakt daneben
 * ein ausgebautes Katalogfeld führt und der Einstieg in die Risikoanalyse in
 * der Maske direkt darüber steht. Wer den Fragebogen ausfüllte, ordnete den
 * Betrieb danach ein zweites Mal von Hand ein.
 *
 * Bewusst dieselbe Komponente wie im Kontakt und nicht eine eigene: Zwei
 * Oberflächen für dieselbe Katalogauswahl waren schon einmal der Grund, warum
 * dieselbe Angabe an zwei Stellen auseinanderlief.
 *
 * Im Antwortsatz steht die Id UND der Anzeigepfad. Die Id ist maßgeblich; der
 * Pfad steht daneben, weil Zusammenfassung, Portal und Kundenbogen den Katalog
 * nicht haben und die Id sonst nicht lesbar machen könnten.
 */
export const BranchenField: React.FC<{
  value: unknown;
  onChange: (wert: BrancheWahl[]) => void;
  idBase: string;
}> = ({ value, onChange, idBase }) => {
  const { rows } = useBrancheClassification();
  const gewaehlt = React.useMemo(() => brancheWahlListe(value), [value]);

  const auswahl: BrancheAuswahl[] = React.useMemo(
    () => gewaehlt.map((w) => ({ brancheClassId: w.brancheClassId })),
    [gewaehlt],
  );

  const uebernehmen = (naechste: BrancheAuswahl[]) => {
    onChange(
      naechste.map((a) => {
        const pfad = formatBranchePath(rows.find((r) => r.id === a.brancheClassId));
        return pfad
          ? { brancheClassId: a.brancheClassId, label: pfad }
          : { brancheClassId: a.brancheClassId };
      }),
    );
  };

  return (
    <BrancheMultiSelect value={auswahl} onChange={uebernehmen} idBase={idBase} />
  );
};
